export const statsConfig = {
  pageviews: 350000,
  tools: 435,
  subscribers: 3350,
  stars: 4600,
}
